export const hexToRgb = (hex: string) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    const rgb = {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    };

    const str = `rgb(${rgb.r},${rgb.g},${rgb.b})`;

    return { rgb, str };
  }
  return null;
};

export const makeColor = (color: string) => {
  const parsed = hexToRgb(color);
  if (parsed) {
    return parsed.rgb.r > 186 ? "#000" : "#fff";
  }
};
